export default __webpack_public_path__ + "static/media/icon-error.d4ce2a26.svg";